import { render, staticRenderFns } from "./userpanelPosts.vue?vue&type=template&id=7a2b220d&scoped=true"
import script from "./userpanelPosts.vue?vue&type=script&lang=js"
export * from "./userpanelPosts.vue?vue&type=script&lang=js"
import style0 from "./userpanelPosts.vue?vue&type=style&index=0&id=7a2b220d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b220d",
  null
  
)

export default component.exports